import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  mainBox: {
    backgroundColor: COLOR_PURPLE,
    padding: theme.spacing(6, 4),

    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(8, 23.62),
    },
  },
  title: {
    fontSize: 30,
    color: theme.palette.common.white,
    lineHeight: '36px',
    textAlign: 'center',
    paddingBottom: theme.spacing(2),

    '& span': {
      fontWeight: 700,
    },
  },
  description: {
    fontSize: 20,
    lineHeight: '24px',
    color: theme.palette.common.white,
    textAlign: 'center',
    paddingBottom: theme.spacing(5),

    '& span': {
      fontWeight: 700,
    },
  },
}));
